import { form } from "./form.js"; // Предполагается, что form.js существует и нужен для grecaptchaCallback
import { displayMessage } from "../alert/messageFunc.js";
import { translate } from "../helpers/translations.js";

// Define RECAPTCHA_SITE_KEY directly instead of importing from common.js to avoid circular dependency
const RECAPTCHA_SITE_KEY = '6LcNV1MUAAAAAOpu34UqnElVsp3je7cP2EapdYbi';

// Для старой логики grecaptchaCallback, если она используется где-то еще
export function grecaptchaCallback(response) {
    let $recaptchas = $('textarea.g-recaptcha-response');
    let $filledRecaptchas = $recaptchas.filter((i, el) => el.value);
    $filledRecaptchas.each((i, el) => form(el));
}

// Глобальные переменные reCAPTCHA
let recaptchaWidgetId = null;
let isRecaptchaApiLoaded = false;
let currentChallengeCallbacks = {}; // Для хранения колбэков текущей проверки
let isRecaptchaWidgetInitialized = false;

// Elements will be initialized in the DOMContentLoaded event
let recaptchaModalElement = null;
let recaptchaContainerInModal = null;
let modalErrorMessageBlock = null;
let modalErrorMessageElement = null;

// 1. Callback, вызываемый при загрузке API reCAPTCHA
function onRecaptchaApiLoad() {
    console.log('reCAPTCHA API loaded.');
    isRecaptchaApiLoaded = true;
    
    // Инициализируем виджет, если DOM уже загружен
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        initializeElements();
        initRecaptchaWidget();
    }
}
window.onRecaptchaApiLoad = onRecaptchaApiLoad; // Make globally available for reCAPTCHA API

// Function to safely initialize DOM elements
function initializeElements() {
    if (!recaptchaModalElement) {
        recaptchaModalElement = document.getElementById('recaptchaModal');
    }
    if (!recaptchaContainerInModal) {
        recaptchaContainerInModal = document.getElementById('recaptcha-container-in-modal');
    }
    if (!modalErrorMessageBlock) {
        modalErrorMessageBlock = document.getElementById('modal-error-message__block');
    }
    if (!modalErrorMessageElement) {
        modalErrorMessageElement = document.getElementById('modal-error-message');
    }
}

// Функция для инициализации виджета reCAPTCHA
function initRecaptchaWidget() {
    initializeElements();
    
    if (!isRecaptchaApiLoaded || isRecaptchaWidgetInitialized || !recaptchaContainerInModal) {
        return;
    }

    try {
        if (typeof grecaptcha !== 'undefined' && grecaptcha && grecaptcha.render) {
            recaptchaWidgetId = grecaptcha.render(recaptchaContainerInModal, {
                'sitekey': RECAPTCHA_SITE_KEY,
                'callback': internalOnRecaptchaSuccess,
                'expired-callback': internalOnRecaptchaExpired,
                'error-callback': internalOnRecaptchaError,
                'size': 'normal',
                'theme' : 'dark'
            });
            isRecaptchaWidgetInitialized = true;
            console.log('reCAPTCHA widget initialized with ID:', recaptchaWidgetId);
        } else {
            console.warn('grecaptcha is not defined or missing render method');
        }
    } catch (error) {
        console.error("Error pre-rendering reCAPTCHA widget:", error);
        // Не показываем ошибку пользователю на этом этапе
    }
}

// Внутренняя функция для закрытия модального окна
function internalCloseRecaptchaModal(isCancelled = false) {
    initializeElements();
    
    if (recaptchaModalElement) {
        recaptchaModalElement.classList.remove('open');
        recaptchaModalElement.classList.remove('show'); // Убедимся, что убираем 'show'
    }
    if (recaptchaWidgetId !== null && typeof grecaptcha !== 'undefined' && grecaptcha && grecaptcha.reset) {
        try {
            grecaptcha.reset(recaptchaWidgetId);
        } catch (e) {
            console.warn("Error resetting reCAPTCHA widget:", e);
        }
    }
    if (isCancelled && typeof currentChallengeCallbacks.onCancel === 'function') {
        currentChallengeCallbacks.onCancel();
    }
    currentChallengeCallbacks = {}; // Сбросить колбэки
}

// 2. Функция для инициации проверки reCAPTCHA
export function showRecaptchaChallenge(callbacks) {
    initializeElements();
    
    if (!isRecaptchaApiLoaded) {
        displayMessage(translate('Recaptcha system is still loading. Please wait a few seconds and try again.'), 'error', translate('Error'));
        if (typeof callbacks.onError === 'function') {
            callbacks.onError('API not loaded');
        }
        return;
    }
    if (!recaptchaModalElement || !recaptchaContainerInModal || !modalErrorMessageElement || !modalErrorMessageBlock) {
        console.error('Recaptcha modal elements not found');
        if (typeof callbacks.onError === 'function') {
            callbacks.onError('Modal elements not found');
        }
        return;
    }

    currentChallengeCallbacks = callbacks || {}; // Сохраняем колбэки с fallback

    modalErrorMessageElement.textContent = '';
    modalErrorMessageBlock.style.display = 'none';
    recaptchaModalElement.classList.add('open');
    recaptchaModalElement.classList.add('show');

    // Проверяем, инициализирован ли виджет
    if (!isRecaptchaWidgetInitialized) {
        try {
            initRecaptchaWidget();
        } catch (error) {
            console.error("Error rendering reCAPTCHA:", error);
            modalErrorMessageElement.textContent = translate('Failed to load verification. Please refresh the page and try again.');
            modalErrorMessageBlock.style.display = '';
            if (typeof currentChallengeCallbacks.onError === 'function') {
                currentChallengeCallbacks.onError(error.message || 'Render error');
            }
        }
    } else if (typeof grecaptcha !== 'undefined' && grecaptcha && grecaptcha.reset) {
        // Если виджет уже был инициализирован, просто сбросим его
        grecaptcha.reset(recaptchaWidgetId);
    }
}

// 3. Внутренние Callback-функции reCAPTCHA
function internalOnRecaptchaSuccess(token) {
    console.log('reCAPTCHA token:', token);
    initializeElements();
    
    if (modalErrorMessageElement && modalErrorMessageBlock) {
        modalErrorMessageElement.textContent = '';
        modalErrorMessageBlock.style.display = 'none';
    }

    if (typeof currentChallengeCallbacks.onSuccess === 'function') {
        currentChallengeCallbacks.onSuccess(token);
    } else {
        console.warn("onSuccess callback for reCAPTCHA challenge is not defined.");
        // Если нет обработчика, лучше закрыть, чтобы не зависало
        internalCloseRecaptchaModal(true);
    }
}

function internalOnRecaptchaExpired() {
    console.warn('Recaptcha token expired.');
    initializeElements();
    
    if (modalErrorMessageElement && modalErrorMessageBlock) {
        modalErrorMessageElement.textContent = translate('Verification timed out. Please complete it again.');
        modalErrorMessageBlock.style.display = '';
    }
    if (typeof currentChallengeCallbacks.onExpired === 'function') {
        currentChallengeCallbacks.onExpired();
    }
    // Виджет сам предложит пройти проверку заново, не закрываем модалку
}

function internalOnRecaptchaError(error) {
    console.error('Recaptcha error:', error);
    initializeElements();
    
    if (modalErrorMessageElement && modalErrorMessageBlock) {
        modalErrorMessageElement.textContent = translate('Verification error. Please refresh the page or try again.');
        modalErrorMessageBlock.style.display = '';
    }
    if (typeof currentChallengeCallbacks.onError === 'function') {
        currentChallengeCallbacks.onError(error || 'Unknown reCAPTCHA error');
    }
}

// 4. Экспортируемая функция для закрытия модального окна извне (например, после успешного логина)
export function closeRecaptchaModal() {
    internalCloseRecaptchaModal(false); // false - не считать отменой от пользователя
}

// 5. Инициализация обработчиков закрытия для самого модального окна reCAPTCHA
document.addEventListener('DOMContentLoaded', () => {
    initializeElements();
    
    if (recaptchaModalElement) {
        const closeButton = recaptchaModalElement.querySelector('.block__item-link.js-close.close-icon');
        if (closeButton) {
            closeButton.addEventListener('click', () => internalCloseRecaptchaModal(true));
        }

        recaptchaModalElement.addEventListener('click', (event) => {
            if (event.target === recaptchaModalElement || event.target.classList.contains('item-close')) {
                internalCloseRecaptchaModal(true);
            }
        });

        const modalWrapper = recaptchaModalElement.querySelector('.modal-wrapper.modal-content');
        if (modalWrapper) {
            modalWrapper.addEventListener('click', (event) => {
                if (event.target === modalWrapper) {
                    internalCloseRecaptchaModal(true);
                }
            });
        }
        
        // Инициализируем reCAPTCHA виджет, если API уже загружен
        if (isRecaptchaApiLoaded) {
            initRecaptchaWidget();
        }
    }
});